import { FileClient } from "..";

export type B020040Request = {
  uridenpyohakozumiKbn: string;
  denpyoshubetsuCd: string;
} & Partial<{
  shukaYmd: string;
  uridenpyoNoFrom: string;
  uridenpyoNoTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCdFrom: string;
  tokuishitenCdFrom: string;
  tokuiCdTo: string;
  tokuishitenCdTo: string;
}>;

//印刷処理
export const B020040Print = (props: B020040Request) => {
  return FileClient.put("b020040/put/print", props);
};
